import { authHeader } from '@/_helpers'
export const clientsService = {
  getAll,
  getBilling,
  modifyCredit,
  modifyTrial,
  create,
  verifyHash,
  getUserTeam,
  setParameters,
  getPriceMeeting,
  setAgency,
  getAgency,
  deleteAgency,
  getProposalAgency,
  searchAgencies,
  searchAgenciesTotal,
  importWord,
  deleteWords,
  getBlacklist,
  getNylasEmails,
  getCalendarNylas,
  getAllCalendarNylas,
  setExistantCalendar,
  getClientActivity,
  getEmailActivity,
  sendToCrm,
  getBlacklistTotal,
  getApolloDomain,
  regenerateEvent,
  deleteAllBlacklist,
  getBdrClients,
  getColdMeetingRate,
  getColdMeetingRateByTarget,
  assignUserOliverExecutiveToClient,
  updateFormation,
  getStats,
  getAffiliate,
  getClientsToBookers,
  getAvgMeetingByClient,
  getElevenLabsCalls,
  getSignedClients,
  getReportPaymentClient,
  getSubscribers,
  getAiContext,
  getAIContextByTarget,
  getClientsMeetingRateDrop,
  getCallKpiRiskAccounts,
  getClientLaunchings,
  createClientNote,
  getClientNotes,
  getClientsForAffiliation,
  getAMbyClient,
  getAIMeetingsReplay,
  getContractClient,
  getClientDocs,
  diagnosticClient,
  getClientSpace,
}

const apiUrl = process.env.VUE_APP_ROOT_API

function importWord(domains) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify(domains),
  }

  return fetch(
    `${apiUrl}/clients/import-excluded-domains`,
    requestOptions,
  ).then(handleResponse)
}


function regenerateEvent(data) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader('application/json'),
        body: JSON.stringify({data})
    };
    return fetch(`${apiUrl}/clients/generate-event`, requestOptions).then(handleResponse);
}

function getAllCalendarNylas(filters) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify({filters}),
  }
  return fetch(`${apiUrl}/clients/get-all-calendar-nylas`, requestOptions).then(
    handleResponse,
  )
}

function getClientActivity(client_id, thisweek) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify({ client_id, thisweek }),
  }
  return fetch(`${apiUrl}/clients/client-activity`, requestOptions).then(
    handleResponse,
  )
}

function getEmailActivity(user_id) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify({ user_id }),
  }
  return fetch(`${apiUrl}/clients/email-activity`, requestOptions).then(
    handleResponse,
  )
}

function sendToCrm(id) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify({ id }),
  }
  return fetch(`${apiUrl}/clients/send-to-crm`, requestOptions).then(
    handleResponse,
  )
}

function getCalendarNylas() {
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify({}),
  }
  return fetch(`${apiUrl}/clients/get-calendar-nylas`, requestOptions).then(
    handleResponse,
  )
}

function assignUserOliverExecutiveToClient(account_executive_user_id, client_id){
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify({ account_executive_user_id, client_id }),
  }
  return fetch(`${apiUrl}/clients/assign-account-executive`, requestOptions).then(
    handleResponse,
  )
}

function setExistantCalendar(nylasAccount, calendar_link) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify({ nylasAccount, calendar_link }),
  }
  return fetch(`${apiUrl}/clients/set-calendar-nylas`, requestOptions).then(
    handleResponse,
  )
}

function getNylasEmails(user_id, limit, page) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify({ user_id, limit, page }),
  }
  return fetch(`${apiUrl}/users/get-nylas-emails`, requestOptions).then(
    handleResponse,
  )
}

function deleteWords() {
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify(),
  }

  return fetch(`${apiUrl}/clients/delete-words`, requestOptions).then(
    handleResponse,
  )
}

function deleteAllBlacklist(client_id) {
  const requestOptions = {
  method: 'DELETE',
  headers: authHeader('application/json'),
  body: JSON.stringify({ client_id }),
  }
  
  let url = `${apiUrl}/clients/delete-all-blacklist`
  if(client_id != undefined && client_id != null) {
  url += `?client_id=${client_id}`
  }
  return fetch(url, requestOptions).then(
  handleResponse,
  )
}

function getAll() {
  const requestOptions = {
    method: 'GET',
    headers: authHeader('application/json'),
  }
  return fetch(`${apiUrl}/clients/`, requestOptions).then(handleResponse)
}



function getReportPaymentClient(params) {
  const cleanParams = Object.fromEntries(
    Object.entries(params || {}).filter(([_, v]) => v !== null && v !== undefined)
  );

  const queryString = new URLSearchParams(cleanParams).toString();
  const url = queryString 
    ? `${apiUrl}/clients/get-report-payment-client?${queryString}`
    : `${apiUrl}/clients/get-report-payment-client`;

  const requestOptions = {
    method: 'GET',
    headers: authHeader('application/json'),
  }
  return fetch(url, requestOptions).then(
    handleResponse,
  )
}

function getPriceMeeting() {
  const requestOptions = {
    method: 'GET',
    headers: authHeader('application/json'),
  }
  return fetch(`${apiUrl}/clients/price-meeting`, requestOptions).then(
    handleResponse,
  )
}
function getBdrClients(data){
    const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify({ data }),
  }
  return fetch(
    `${apiUrl}/clients/get-bdr-clients`,
    requestOptions,
  ).then(handleResponse)

}
function getBilling(date, type) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader('application/json'),
  }
  return fetch(
    `${apiUrl}/billings/?dateRange=${date}&type=${type}`,
    requestOptions,
  ).then(handleResponse)
}

function getUserTeam(user_id) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader('application/json'),
  }

  return fetch(
    `${apiUrl}/clients/all-users-team/${user_id}`,
    requestOptions,
  ).then(handleResponse)
}

function create(company, website) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify({ company, website }),
  }

  return fetch(`${apiUrl}/clients/create`, requestOptions).then(handleResponse)
}

function setParameters(data) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify(data),
  }

  return fetch(`${apiUrl}/clients/parameters`, requestOptions).then(
    handleResponse,
  )
}

function modifyCredit(id, amount, description, link_id, reason) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify({ id, amount, description , link_id, reason }),
  }

  return fetch(`${apiUrl}/clients/modify-credit`, requestOptions).then(
    handleResponse,
  )
}

function modifyTrial(data) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify({ data }),
  }

  return fetch(`${apiUrl}/clients/modify-trial`, requestOptions).then(
    handleResponse,
  )
}

function verifyHash(hash) {
  const requestOptions = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ hash }),
  }

  return fetch(`${apiUrl}/clients/verify-hash`, requestOptions).then(
    handleResponse,
  )
}

function setAgency(model) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify({ model }),
  }

  return fetch(`${apiUrl}/clients/agency`, requestOptions).then(handleResponse)
}

function getAgency(clientId) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader('application/json'),
  }

  return fetch(`${apiUrl}/clients/agency/${clientId}`, requestOptions).then(
    handleResponse,
  )
}

function getClientsForAffiliation(){
  const requestOptions = {
    method: 'GET',
    headers: authHeader('application/json'),
  }

  return fetch(`${apiUrl}/clients/get-client-for-affiliation?cache=true&time=10800`, requestOptions).then(
    handleResponse,
  )
}

function deleteAgency(data) {
  const requestOptions = {
    method: 'DELETE',
    headers: authHeader('application/json'),
    body: JSON.stringify({ data }),
  }

  return fetch(`${apiUrl}/clients/agency`, requestOptions).then(handleResponse)
}

function getProposalAgency(clientHash) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader('application/json'),
  }

  return fetch(
    `${apiUrl}/clients/proposal/agency/${clientHash}`,
    requestOptions,
  ).then(handleResponse)
}

function searchAgencies(model) {
  model.total = 0
  let searchFilter = getDefault(model)
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify({ searchFilter }),
  }

  return fetch(`${apiUrl}/clients/get-agencies`, requestOptions).then(
    handleResponse,
  )
}

function searchAgenciesTotal(model) {
  model.total = 1
  let searchFilter = getDefault(model)
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify({ searchFilter }),
  }

  return fetch(`${apiUrl}/clients/get-agencies`, requestOptions).then(
    handleResponse,
  )
}

function getBlacklist(page, client_id, all_items = 0) {
  const requestOptions = {
  method: 'GET',
  headers: authHeader('application/json'),
  }
  let url = `${apiUrl}/clients/blacklist/${page}`
  if(client_id != undefined && client_id != null) {
    url += `?client_id=${client_id}`
  }  
  if(all_items != 0) {
    url += `?all_items=${all_items}`
  }  
  return fetch(url, requestOptions).then(handleResponse)
}


function getBlacklistTotal(client_id) {
  const requestOptions = {
  method: 'GET',
  headers: authHeader('application/json'),
  }
  let url = `${apiUrl}/clients/blacklist-total`
  if(client_id != undefined && client_id != null) {
  url += `?client_id=${client_id}`
  }
  return fetch(url, requestOptions).then(handleResponse)
}

function getColdMeetingRate(clients) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify({ clients }),
  }

  return fetch(`${apiUrl}/clients/cold-meeting-rate`, requestOptions).then(
    handleResponse,
  )
}

function getAvgMeetingByClient(clients) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify({ clients }),
  }

  return fetch(`${apiUrl}/clients/avg-meeting-by-client`, requestOptions).then(
    handleResponse,
  )
}

function getColdMeetingRateByTarget(targets) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify({ targets }),
  }

  return fetch(`${apiUrl}/clients/cold-meeting-rate-target`, requestOptions).then(
    handleResponse,
  )
}

function getClientsMeetingRateDrop(account_manager = 0) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader('application/json'),
  }
  const params = new URLSearchParams()
  if (account_manager != null && account_manager !== '' && Number(account_manager) > 0) {
    params.append('account_manager', String(account_manager))
  }
  const query = params.toString() ? `?${params.toString()}` : ''
  return fetch(`${apiUrl}/clients/clients-meeting-rate-drop${query}`, requestOptions).then(
    handleResponse,
  )
}

function getCallKpiRiskAccounts(clientId) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader('application/json'),
  }
  const params = new URLSearchParams({ client_id: String(clientId) })
  return fetch(
    `${apiUrl}/clients/get-call-kpi-risk-accounts?${params.toString()}`,
    requestOptions,
  ).then(handleResponse)
}

function diagnosticClient(payload) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify(payload),
  }

  return fetch(`${apiUrl}/clients/diagnostic-client`, requestOptions).then(
    handleTextResponse,
  )
}

function getClientsToBookers(bookers) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify({ bookers }),
  }

  return fetch(`${apiUrl}/clients/clients-to-bookers`, requestOptions).then(
    handleResponse,
  )
}

function updateFormation(client_id, formation){
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify({ client_id, formation }),
  }

  return fetch(`${apiUrl}/clients/update-formation`, requestOptions).then(
    handleResponse,
  )
}

function getElevenLabsCalls(clientId) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify({ clientId }),
  }
  return fetch(`${apiUrl}/clients/get-elevenlab-calls`, requestOptions).then(
    handleResponse
  )
}
function getSignedClients(params) {
    const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify({ params }),
  }
  return fetch(`${apiUrl}/clients/get-signed-clients`, requestOptions).then(
    handleResponse
  )
}
//
function getApolloDomain(data,token) {
  const requestOptions = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ data,token }),
  }

  return fetch(`${apiUrl}/clients/check-apollo-domain`, requestOptions).then(
    handleResponse,
  )
}

function getStats(clientId) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify({ clientId }),
  }

  return fetch(`${apiUrl}/clients/get-stats`, requestOptions).then(
    handleResponse,
  )
}

function getAffiliate(params) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify({ params }),
  }

  return fetch(`${apiUrl}/clients/get-affiliate`, requestOptions).then(
    handleResponse,
  )
}

function getSubscribers(clientStatusIds, pauseSubscription = 0) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader('application/json'),
  }
  
  const statusIdsParam = Array.isArray(clientStatusIds) 
    ? clientStatusIds.join(',') 
    : clientStatusIds;
  
  const url = `${apiUrl}/clients/get-subscribers?client_status_id=${statusIdsParam}&pause_subscription=${pauseSubscription}`;
  
  return fetch(url, requestOptions).then(handleResponse)
}

function getAiContext(clientId) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader('application/json'),
  }
  return fetch(`${apiUrl}/clients/${clientId}/get-ai-context`, requestOptions).then(
    handleResponse,
  )
}

function getAIContextByTarget(targetId) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader('application/json'),
  }
  return fetch(`${apiUrl}/clients/${targetId}/get-ai-context-by-target`, requestOptions).then(
    handleResponse,
  )
}

function getClientLaunchings() {
  const requestOptions = {
    method: 'GET',
    headers: authHeader('application/json'),
  }
  return fetch(`${apiUrl}/clients/get-clients-with-launchings`, requestOptions).then(
    handleResponse,
  )
}

function createClientNote(client_id, client_note_topic_id, message) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify({ client_id, client_note_topic_id, message }),
  }
  return fetch(`${apiUrl}/clients/client-note`, requestOptions).then(
    handleResponse,
  )
}

function getClientNotes(client_id, client_note_topic_id) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader('application/json'),
  }
  const params = new URLSearchParams({ client_id: String(client_id) })
  if (client_note_topic_id != null && client_note_topic_id !== '') {
    params.append('client_note_topic_id', client_note_topic_id)
  }
  return fetch(`${apiUrl}/clients/client-notes?${params.toString()}`, requestOptions).then(
    handleResponse,
  )
}

function getAMbyClient(client_id) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader('application/json'),
  }
  return fetch(`${apiUrl}/clients/get-account-manager-by-client/${client_id}`, requestOptions).then(
    handleResponse,
  )
}

function getAIMeetingsReplay(currentPage = 0, cantPerPage = 0, getTotal = 0) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader('application/json'),
  }
  return fetch(`${apiUrl}/clients/get-meetings-replays?currentPage=${currentPage}&cantPerPage=${cantPerPage}&getTotal=${getTotal}`, requestOptions).then(
    handleResponse,
  )
}

function getContractClient(client_id){
  const requestOptions = {
    method: 'GET',
    headers: authHeader('application/json'),
  }
  return fetch(`${apiUrl}/clients/get-contract?client_id=${client_id}`, requestOptions).then(
    handleBlobDownloadResponse,
  )
}

function getClientSpace(user_id, client_id){
  const requestOptions = {
    method: 'GET',
    headers: authHeader('application/json'),
  }
  return fetch(`${apiUrl}/clients/get-client-space?user_id=${user_id}&client_id=${client_id}`, requestOptions).then(
    handleResponse,
  )
}

function getClientDocs(filters = {}) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader('application/json'),
  }
  const params = new URLSearchParams()
  if (filters.client_id != null && filters.client_id !== '') {
    params.set('client_id', filters.client_id)
  }
  if (filters.currentPage != null) {
    params.set('currentPage', filters.currentPage)
  }
  if (filters.cantPerPage != null) {
    params.set('cantPerPage', filters.cantPerPage)
  }
  if (filters.getTotal != null) {
    params.set('getTotal', filters.getTotal)
  }
  const query = params.toString() ? `?${params.toString()}` : ''
  return fetch(`${apiUrl}/clients/get-client-docs${query}`, requestOptions).then(handleResponse)
}

function getDefault(model) {
  let searchFilter = Array()
  searchFilter = {
    clientSubscriptions: model.clientSubscriptions !== undefined ? JSON.stringify(model.clientSubscriptions) : undefined,
    oliver_sale: model.oliver_sale !== undefined ? JSON.stringify(model.oliver_sale) : undefined,
    fullstats: model.fullstats !== undefined ? JSON.stringify(model.fullstats) : undefined,
    currentPage:
      model.currentPage !== undefined
        ? JSON.stringify(model.currentPage)
        : undefined,
    cantPerPage:
      model.cantPerPage !== undefined
        ? JSON.stringify(model.cantPerPage)
        : undefined,
    total: model.total !== undefined ? JSON.stringify(model.total) : undefined,
    clientStatusId:
      model.clientStatusId !== undefined
        ? JSON.stringify(model.clientStatusId)
        : undefined,
    recoveryByMailbox:
      model.recoveryByMailbox !== undefined
        ? JSON.stringify(model.recoveryByMailbox)
        : undefined,
    getcomplete:
      model.getcomplete !== undefined
        ? JSON.stringify(model.getcomplete)
        : undefined,
    filters:
      model.searchFilter !== undefined ? model.searchFilter.filters : undefined,
    order: model.order !== undefined ? model.order : undefined,
  }
  return searchFilter
}
function handleResponse(response) {
  return response.text().then((text) => {
    const data = text && JSON.parse(text)
    if (!response.ok) {
      const error = data || response.statusText
      return Promise.reject(error)
    }
    return data
  })
}

function handleTextResponse(response) {
  return response.text().then((text) => {
    if (!response.ok) {
      let error = text || response.statusText
      try {
        const parsed = text && JSON.parse(text)
        error = (parsed && (parsed.message || parsed.error)) || parsed || error
      } catch (e) {}
      return Promise.reject(error)
    }
    return text
  })
}

function filenameFromContentDisposition(header) {
  if (!header) return null;

  // filename*=UTF-8''nombre.pdf (RFC 5987)
  const utf8Match = header.match(/filename\*=UTF-8''([^;\n]+)/i);
  if (utf8Match) {
    try {
      return decodeURIComponent(utf8Match[1].trim());
    } catch (e) {
      return utf8Match[1].trim();
    }
  }

  // filename="contract-ABC.pdf"
  const quotedMatch = header.match(/filename="([^"]+)"/i);
  if (quotedMatch) return quotedMatch[1];

  // filename=contract-ABC.pdf
  const unquotedMatch = header.match(/filename=([^;\n]+)/i);
  if (unquotedMatch) {
    return unquotedMatch[1].trim().replace(/^"|"$/g, '');
  }

  return null;
}


function handleBlobDownloadResponse(response) {
    if (!response.ok) {
        return response.text().then((text) => {
            let error = response.statusText;
            try {
                const parsed = text && JSON.parse(text);
                error =
                    typeof parsed === 'string'
                        ? parsed
                        : (parsed && parsed.message) || (parsed && parsed.error) || error;
            } catch (e) {
                if (text) {
                    error = text.slice(0, 200);
                }
            }
            return Promise.reject(error);
        });
    }
    const filename = filenameFromContentDisposition(
        response.headers.get('Content-Disposition'),
    );
    return response.blob().then((blob) => ({ blob, filename }));
}
